
export enum MainOptions {
    ResortSize = "Resort Size",
    Luxury = "Luxury",
    Location = "Location",
    RoomType = "Room Type",
    ResortStyle = "Resort Style",
    Why = "Why",
    Trip = "Trip",
    CampStyle = "Camp Style",
    PriceRange = "Price Range",
    Interest = "Interest",
}

export enum ResortSizeOptions {
    fiftyorless = '50 Or Less',
    fiftyormore = '50 Or More'
}

export enum LuxuryOptions {
    fourstar = '4-Star',
    fourandhalf = '4 ½-stars',
    fivestar = '5-Star',
    fiveandhalf = '5 ½-stars',
    sixstar = '6-Stars',
    superluxury = 'Super Luxury',
}

export enum RoomTypeOptions {
    villawithpool = 'Villa with a pool',
    multibedroomvilla = 'Multi-bedroom villa',
    overwatervilla = 'Overwater villa',
    withpooloverwatervilla = 'Overwater Villa With Pool',
    beachvilla = 'Beach villa',
    beachvillawithpool = 'Beach villa with pool',
    multibedroomoverwatervilla = 'Multi-bedroom overwater villa',
    multibedroombeachvilla = 'Multi-bedroom beach villa',
    privateyacht = 'Private yacht',
}

export enum ResortStyleOptions {
    authentic = 'Authentic Luxury',
    barefoot = 'Barefoot Luxury',
    modern = 'Modern Luxury',
    elegant = 'Elegant Luxury',
}

export enum WhyOptions {
    romantic = 'Romantic',
    foodie = 'Foodie Focus',
    family = 'Family friendly',
    diving = 'Best for diving',
    housereef = 'Best house reef',
    activities = 'Best for activities',
    spafocus = 'Spa focus',
    golf = 'Golf',
    kitesurfing = 'Kite Surfing',
    surfing = 'Surfing',
}

export enum LocationOptions {
    city = 'City',
    beach = 'Beach',
    palm = 'The Palm',
    beachcity = 'Beach/City',
    desert = 'Desert',
    north = 'North',
    east = 'East',
    south = 'South',
    west = 'West',
    mahe = 'Mahé',
    ladigue = 'La Digue',
    praslin = 'Praslin',
    privateisland = 'Private Island',
    safari = 'Safari',
    culturaltriangle = 'Cultural Triangle',
}

export enum TripOptions {
    onetofournights = "1-4 nights",
    fivetosevennights = "5-7 nights",
    eightplusnights = "8+ nights",
}
export enum PriceRangeOptions {
    $800to1000 = "$800-1000",
    $1001to$2000 = "$1001 - $2000",
    $2001plus = "$2001+",
}
export enum InterestOptions {
    Firsttimesafari = "First time safari",
    WalkingSafari = "Walking safari",
    Foodiefocus = "Foodie focus",
    Boatsafari = "Boat safari",
}


// ** Options Map

export interface OptionsMap {
    [MainOptions.ResortSize]? : ResortSizeOptions[]
    [MainOptions.Luxury]? : LuxuryOptions[],
    [MainOptions.CampStyle]? : ResortStyleOptions[],
    [MainOptions.Location]? : LocationOptions[],
    [MainOptions.RoomType]? : RoomTypeOptions[],
    [MainOptions.ResortStyle]? : ResortStyleOptions[],
    [MainOptions.Why]? : WhyOptions[],
    [MainOptions.PriceRange]? : PriceRangeOptions[],
    [MainOptions.Interest]? : InterestOptions[],
    [MainOptions.Trip]? : TripOptions[],
}

// ****************************************

// ** Data Options Per Destinations

// ***************************************


export const DefaultOptions : OptionsMap = {
    [MainOptions.ResortSize] : [
        ResortSizeOptions['fiftyorless'],
        ResortSizeOptions['fiftyormore'],
    ],
    [MainOptions.Luxury] : [
        LuxuryOptions['fourandhalf'],
        LuxuryOptions['fourstar'],
        LuxuryOptions['fiveandhalf'],
        LuxuryOptions['fivestar'],
        LuxuryOptions['sixstar'],
        LuxuryOptions['superluxury'],
    ],
    [MainOptions.RoomType] : [
        RoomTypeOptions['villawithpool'],
        RoomTypeOptions['multibedroomvilla'],
        RoomTypeOptions['overwatervilla'],
        RoomTypeOptions['withpooloverwatervilla'],
        RoomTypeOptions['beachvilla'],
        RoomTypeOptions['beachvillawithpool'],
        RoomTypeOptions['multibedroomoverwatervilla'],
        RoomTypeOptions['multibedroombeachvilla'],
        RoomTypeOptions['privateyacht'],
    ],
    [MainOptions.ResortStyle] : [
        ResortStyleOptions['authentic'],
        ResortStyleOptions['barefoot'],
        ResortStyleOptions['elegant'],
        ResortStyleOptions['modern'],
    ],
    [MainOptions.Why] : [
        WhyOptions['foodie'],
        WhyOptions['family'],
        WhyOptions['diving'],
        WhyOptions['housereef'],
        WhyOptions['romantic'],
        WhyOptions['activities'],
        WhyOptions['spafocus'],
        WhyOptions['golf'],
        WhyOptions['kitesurfing'],
        WhyOptions['surfing'],
    ]
}

export const AbuDhabiOptions : OptionsMap = {
    [MainOptions.Location]: [
        LocationOptions['beachcity'],
        LocationOptions['desert'],
    ],
    [MainOptions.Luxury]: [
        LuxuryOptions['fivestar'],
        LuxuryOptions['fiveandhalf'],
    ],
}

export const DubaiOptions : OptionsMap = {
    [MainOptions.Location]: [
        LocationOptions['city'],
        LocationOptions['beach'],
        LocationOptions['palm'],
        LocationOptions['desert'],
    ],
    [MainOptions.Luxury]: [
        LuxuryOptions['fivestar'],
        LuxuryOptions['fiveandhalf'],
        LuxuryOptions['superluxury'],
    ],

}

export const MaldivesOptions : OptionsMap = {
    [MainOptions.ResortSize] : [
        ResortSizeOptions['fiftyorless'],
        ResortSizeOptions['fiftyormore'],
    ],
    [MainOptions.Luxury] : [
        LuxuryOptions['fivestar'],
        LuxuryOptions['fiveandhalf'],
        LuxuryOptions['sixstar'],
        LuxuryOptions['superluxury'],
    ],
    [MainOptions.RoomType] : [
        RoomTypeOptions['overwatervilla'],
        RoomTypeOptions['withpooloverwatervilla'],
        RoomTypeOptions['beachvilla'],
        RoomTypeOptions['multibedroomoverwatervilla'],
        RoomTypeOptions['multibedroombeachvilla'],
        RoomTypeOptions['privateyacht'],
    ],
    [MainOptions.ResortStyle] : [
        ResortStyleOptions['barefoot'],
        ResortStyleOptions['modern'],
        ResortStyleOptions['elegant'],
    ],
    [MainOptions.Why] : [
        WhyOptions['romantic'],
        WhyOptions['foodie'],
        WhyOptions['family'],
        WhyOptions['diving'],
        WhyOptions['housereef'],
        WhyOptions['spafocus'],
        WhyOptions['surfing'],
    ]
}

export const MauritiusOptions : OptionsMap = {
    [MainOptions.Location] : [
        LocationOptions['north'],
        LocationOptions['east'],
        LocationOptions['south'],
        LocationOptions['west'],
    ],
    [MainOptions.Luxury] : [
        LuxuryOptions['fourstar'],
        LuxuryOptions['fivestar'],
        LuxuryOptions['fiveandhalf'],
    ],
    [MainOptions.Why] : [
        WhyOptions['romantic'],
        WhyOptions['family'],
        WhyOptions['golf'],
        WhyOptions['kitesurfing'],
    ]
}

export const SeychellesOptions : OptionsMap = {
    [MainOptions.Location] : [
        LocationOptions['mahe'],
        LocationOptions['ladigue'],
        LocationOptions['praslin'],
        LocationOptions['privateisland'],
    ],
    [MainOptions.Luxury] : [
        LuxuryOptions['fourandhalf'],
        LuxuryOptions['fivestar'],
        LuxuryOptions['fiveandhalf'],
        LuxuryOptions['superluxury'],
    ],
    [MainOptions.RoomType] : [
        RoomTypeOptions['villawithpool'],
        RoomTypeOptions['multibedroomvilla']
    ],
    [MainOptions.ResortStyle] : [
        ResortStyleOptions['barefoot'],
        ResortStyleOptions['modern'],
        ResortStyleOptions['elegant'],
    ],
    [MainOptions.Why] : [
        WhyOptions['romantic'],
        WhyOptions['family'],
        WhyOptions['activities'],
        WhyOptions['spafocus'],
    ]
}

export const SouthernAfricaOptions : OptionsMap = {
    [MainOptions.Trip] : [
        TripOptions['onetofournights'],
        TripOptions['fivetosevennights'],
        TripOptions['eightplusnights'],
    ],
    [MainOptions.PriceRange] : [
        PriceRangeOptions['$800to1000'],
        PriceRangeOptions['$1001to$2000'],
        PriceRangeOptions['$2001plus'],
    ],
    [MainOptions.Interest] : [
        InterestOptions['Firsttimesafari'],
        InterestOptions['WalkingSafari'],
        InterestOptions['Foodiefocus'],
        InterestOptions['Boatsafari'],
    ],
    [MainOptions.CampStyle] : [
        ResortStyleOptions['authentic'],
        ResortStyleOptions['modern'],
    ]

}


export const SriLankaOptions : OptionsMap = {
    [MainOptions.Location]: [
        LocationOptions['safari'],
        LocationOptions['beach'],
        LocationOptions['culturaltriangle'],
        LocationOptions['city'],
    ],
}